module.exports = __webpack_public_path__ + "media/images/boy-c1df034635fce67342af54401f81b218.png";